import { createContext, useContext } from "react";

export const ComboboxContext = createContext({
    isAutoApply: false,
    isMultiple: false,
    options: [],
});

export const useComboboxContext = () => useContext(ComboboxContext);